import { render, staticRenderFns } from "./VendedorRankItem.vue?vue&type=template&id=55591c80&"
import script from "./VendedorRankItem.vue?vue&type=script&lang=js&"
export * from "./VendedorRankItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports